<template>
  <div id="channelPacket">
    <el-main>
      <div class="header_p">动态网吧安装方式：<span class="header_span">(不用填写绑定固定IP，但门店的服务器需要挂服务端微端）</span></div>
      <div class="channel_conent">
        <div class="zip_channel">
          <div class="alldown">
            <div>
              <a href="https://cdn-js.yebaojiasu.com/netbar/包月安装教程.pdf" target="_blank" style="margin-right: 24px;">
                <el-button type="danger" size="medium">下载动态网吧安装教程</el-button>
              </a>
              <a v-bind:href="download_url" class="scanning">
                <el-button type="goon" size="medium">下载服务端微端</el-button>
              </a>
              <a v-bind:href="download_url_wdkmg" class="scanning" style="margin-left: 24px;">
                <el-button type="goon" size="medium">下载微端看门狗</el-button>
              </a>
            </div>
            <div class="alldown_package">
              服务端微端链接：
              <span>{{ download_url }}</span>
            </div>
            <div style="color:#F56C6C;font-size:14px;margin-top:10px">
              微端使用说明：<br />
              1、在门店无盘服务器上，下载微端安装包，运行YBProxyAccSrv.exe程序，（微端管理工具作用：客户机通信检测）<br />

              2、再下载微端看门狗YBWatchDogSvr程序，跟微端("YBProxyAccSrv.exe"程序名不可修改防止报错)在同一目录即可，（微端看门狗作用：防止避免微端自动退出）<br />

              3、请输入服务器内网IP，自定义端口，密钥，选择客户端生成目录后，点击开始服务（若出现服务运行中，表示成功）<br />

              4、点击生成客户端，将自动生成拉取客户端程序，并保存在当前目录下面（客户端目录名YBNetbar），由于网路的不稳定性，可能需要等待3-5分钟，当出现生成客户端成功弹窗后，表示客户端下载成功<br />

              5、进入客户端目录（YBNetbar），下发推送客户端YeBao.exe程序至门店客户机设置为快捷桌标即可，安装成功后，不要关闭服务器上的微端管理工具和看门狗程序。<br />
            </div>
          </div>
        </div>
      </div>

      <div class="header_p">静态网吧安装方式：<span class="header_span">(需要填写绑定固定IP，不需要挂服务端微端)</span></div>
      <div class="channel_conent">
        <div class="zip_channel">
          <div class="alldown">
            <div>
              <a href="https://cdn-js.yebaojiasu.com/netbar/包月静态网吧安装教程.pdf" target="_blank" style="margin-right: 24px;">
                <el-button type="danger" size="medium">下载静态网吧安装教程</el-button>
              </a>
              <a v-bind:href="download_url2" class="scanning" style="margin-right: 24px;">
                <el-button type="goon" size="medium">下载包月通用包</el-button>
              </a>
              <a href="/favicon.ico" target="_blank" download="yebao">
                <el-button type="danger" size="medium">下载ICO图标</el-button>
              </a>
            </div>
            <div class="alldown_package">
              通用包链接：
              <span>{{ download_url2 }}</span>
            </div>
            <div style="color:#F56C6C;font-size:14px;margin-top:10px">
              通用包使用说明：<br />
              1、网吧管理列表，创建网吧后，选择“静态”模式并添加网吧静态IP；<br />

              2、下载包月通用包，然后下载相应网吧的配置文件（网吧管理列表），将包月通用包和配置文件放在同目录下；<br />

              3、网吧服务器上推送”launcher.exe“客户机桌面为快捷方式即可，无需做开机启动；<br />

              4、推送桌面为快捷方式后，客户机使用加速器，右上方显示该网吧名字即表示安装成功。<br />
            </div>
          </div>
        </div>
      </div>
    </el-main>
  </div>
</template>

<script>
import * as sysApi from "../common/sys";
export default {
  name: "channelPacket",
  data() {
    return {
      download_url: '',
      download_url2: '',
      download_url_wdkmg: "https://cdn-js.yebaojiasu.com/YBWatchDogSvr1.exe",
    };
  },
  created() {
    this.getdown()
    // this.initSwitch();
  },
  methods: {
    getdown() {
      this.$http2
        .post("https://new-mgr.yebaojiasu.com/api/v1/new_mgr/version", { cv: "1.0.1" })
        .then((res) => {
          if (res.status === 200 && res.data.code === 200) {
            this.download_url = res.data.data.url;
          }
        });

      this.$http2
        .post(this.$api.api.bar_downloads, "account_number=" + localStorage.agent_number)
        .then((res) => {
          console.log(res);
          if (res.data.code != 1) {
            return this.$message.error(res.data.result);
          }
          // this.bardeployclienturlzip = res.data.result.by_zip_url;
          this.download_url2 = res.data.result.file_url;
        });
    },
  }
};
</script>

<style scoped lang="scss">
.title_img {
  width: 800px;
  height: 500px;
}

.explain {
  padding-top: 20px;
  color: #39c2b8;
  font-weight: bold;
  padding-right: 50px;
  font-size: 16px;
}

.addd {
  position: relative;
}

.switvch {
  position: absolute;
  top: 40px;
  left: 40%;
}

.scanning {
  // background: #6692ff;
  // line-height: 40px;
  // padding-left: 20px;
}

.alldown_package {
  margin-top: 20px;
  font-size: 16px;

  span {
    color: #5f95cc;
  }
}

.channel_conent {
  // border: 1px solid #bbbbbb;

  .zip_channel {
    // border-bottom: 1px solid #bbbbbb;
    background: #fff;
    padding: 30px 20px;
    margin-bottom: 30px;

    .title_head {
      margin: 0;
      line-height: 20px;
      font-size: 16px;
      color: #535353;
      margin-bottom: 20px;
    }

    .thing2 {
      padding: 0;
    }

    // padding-bottom: 70px;
  }
}

.header_p {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #535353;
}

.header_span {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #5f95cc;
}

.all_price span {
  font-size: 22px;
  font-weight: bold;
  color: #000;
}

.headerData,
.alldown {
  div {
    position: relative;

    img {
      position: absolute;
      top: 10px;
      left: 8px;
      width: 20px;
      height: 20px;
    }
  }
}

#ul_firest li {
  flex: 3;
}

.thing,
.thing2 {
  overflow: hidden;
  padding-left: 50px;
  padding-bottom: 10px;

}

.thing {
  position: relative;

  img {
    position: absolute;
    top: 10px;
    left: 60px;
    width: 20px;
    height: 20px;
  }
}

.thing a {
  // float: left;

  // color: #fff;
  // width: 180px;
  // text-align: center;
  // border-radius: 0px;
  // padding: 10px 20px;

  // margin-right: 40px;
}

.thing2 a {
  // color: #fff;
  // width: 180px;
  // text-align: center;
  // margin-bottom: 10px;
  // border-radius: 0px;
  // padding: 10px 20px;

}

.thing .download_span {
  float: left;
  color: #000;
  border-radius: 0px;
  padding: 10px 20px;
  margin-right: 40px;
}

.thing>li {
  float: left;
  margin: 5px 10px;
  list-style: none;
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
  background: #fff;

  color: #666;
}

.thing>li>a {
  color: #666;
}

.thing>li>a>p {
  overflow: hidden;
}

.thing>li>a>p>span:nth-child(1) {
  float: left;
}

.thing>li>a>p>span:nth-child(2) {
  float: right;
  color: #ff0000;
}

.fun>li {
  float: left;
  list-style: none;
  margin-right: 15px;
}
</style>